import { Box } from "@chakra-ui/react";

import { QueriesList } from "./QueriesList";
import { QueriesOverview } from "./QueriesOverview";

export const Queries = ({ context }: { context: "company" | "client" }) => (
  <Box px={12} py={10}>
    <QueriesOverview context={context} />
    <QueriesList context={context} />
  </Box>
);
